export default __webpack_public_path__ + "static/rec-2007-43127a674f2af2115b848b7260bc2452.png";